import React from 'react';
export const RouterExtensionContext = React.createContext({
    currentPath: null,
    setCurrentPath: () => null,
});
//# sourceMappingURL=RouterExtension.context.js.map